/**
 * Величины списка выбора в окне «Сгенерировать», общие для самого списка и его скелетона
 * (IMGM-1508). Лежат отдельно от компонента, чтобы скелетон не тянул зависимости экрана
 * (`.claude/docs/skeleton-kit.md`).
 */

/** Предел высоты списка, px: дальше — скролл внутри списка, окно не растёт. */
export const MEDIA_SUBJECT_LIST_MAX_HEIGHT = 320;

/** С какого числа пунктов над списком появляется поиск: короткий список и так виден целиком. */
export const SEARCH_THRESHOLD = 8;

/** Сколько строк в скелетоне короткого списка (туры, этапы, группы — поиска у них обычно нет). */
export const MEDIA_SUBJECT_SKELETON_SHORT_ROW_COUNT = 3;

/**
 * Сколько строк в скелетоне списка матчей. Список матчей во время загрузки рисуется во всю
 * высоту `MEDIA_SUBJECT_LIST_MAX_HEIGHT`; строк берётся с запасом, лишние обрезает скролл.
 */
export const MEDIA_SUBJECT_SKELETON_LONG_ROW_COUNT = 8;

/** Рамка списка; высоту задаёт компонент — замером при первом показе. */
export const MEDIA_SUBJECT_LIST_CLASS = 'border-lineSubtle rounded-card overflow-y-auto border';

/** Строка-пункт списка. */
export const MEDIA_SUBJECT_ROW_CLASS = 'border-lineSubtle flex items-center gap-3 border-b px-3 py-2 last:border-b-0';

/** Заголовок группы (тура) над пунктами. */
export const MEDIA_SUBJECT_GROUP_CLASS = 'bg-surfaceSunken text-inkSecondary sticky top-0 z-1 block px-3 py-1 font-semibold';

/** Радиокнопка строки. */
export const MEDIA_SUBJECT_RADIO_CLASS = 'h-4 w-4 shrink-0';

/**
 * Плашка поля поиска. Высота — та же, что у поля ввода `ud-form`: `height: 36px` в
 * `ud-form/components/input/component/styles.ts` (`h-9`), скругление — `rounded-card`, как там же.
 */
export const MEDIA_SUBJECT_SEARCH_SKELETON_CLASS = 'skeleton-block rounded-card h-9 w-full';
